module.exports = __webpack_public_path__ + "img/celular1.81fca8c8.svg";